import Vue from "vue";
import VueApexCharts from "vue-apexcharts-ukaniow"

Vue.use(VueApexCharts);
Vue.component("Apexchart", VueApexCharts);

export default VueApexCharts;
